export default function stripParams(link: string) {
  const questionMarkIndex = link.indexOf("?");
  if (questionMarkIndex !== -1) {
    link = link.substring(0, questionMarkIndex);
  }
  return link;
}
